import { render, staticRenderFns } from "./postLocation.vue?vue&type=template&id=ac842844&"
import script from "./postLocation.vue?vue&type=script&lang=js&"
export * from "./postLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports